import { render, staticRenderFns } from "./InputChoice.vue?vue&type=template&id=28836744&scoped=true&"
import script from "./InputChoice.vue?vue&type=script&lang=js&"
export * from "./InputChoice.vue?vue&type=script&lang=js&"
import style0 from "./InputChoice.vue?vue&type=style&index=0&id=28836744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28836744",
  null
  
)

export default component.exports